/**
 * @class Sequence
 *
 * @classdesc Represents a sequence of ordered nodes.
 */
export class Sequence {
    /**
     * Create a new sequene instance.
     *
     * @param {ISequence} sequence - Raw sequence data.
     */
    constructor(sequence) {
        this._key = sequence.key;
        this._keys = sequence.keys;
    }
    /**
     * Get key.
     *
     * @returns {string} Unique sequence key.
     */
    get key() {
        return this._key;
    }
    /**
     * Get keys.
     *
     * @returns {Array<string>} Array of ordered node keys in the sequence.
     */
    get keys() {
        return this._keys;
    }
    /**
     * Dispose the sequence.
     *
     * @description Disposes all cached assets.
     */
    dispose() {
        this._key = null;
        this._keys = null;
    }
    /**
     * Find the next node key in the sequence with respect to
     * the provided node key.
     *
     * @param {string} key - Reference node key.
     * @returns {string} Next key in sequence if it exists, null otherwise.
     */
    findNextKey(key) {
        const i = this._keys.indexOf(key);
        if (i + 1 >= this._keys.length || i === -1) {
            return null;
        }
        else {
            return this._keys[i + 1];
        }
    }
    /**
     * Find the previous node key in the sequence with respect to
     * the provided node key.
     *
     * @param {string} key - Reference node key.
     * @returns {string} Previous key in sequence if it exists, null otherwise.
     */
    findPrevKey(key) {
        const i = this._keys.indexOf(key);
        if (i === 0 || i === -1) {
            return null;
        }
        else {
            return this._keys[i - 1];
        }
    }
}
//# sourceMappingURL=Sequence.js.map